
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSleet as ObiSleetElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-sleet.js';
 
 
 

 
 export const ObiSleet = createComponent({
   react: React,
   tagName: 'obi-sleet',
   elementClass: ObiSleetElement,
   events: {
     
   }
  });
 
 